import React from "react";

import styles from "./MultiSelect.module.css";

import IMultiSelectProps from "./dto/IMultiSelectProps";
import MultiSelectState from "./dto/MultiSelectState";
import { Checkbox, ColorClassNames, FontClassNames, Label } from "@fluentui/react";
import MultiSelectConfig from "../../../../dto/Form/MultiSelectConfig";
import MultiSelectConfigOptionGroup from "../../../../dto/Form/MultiSelectConfigOptionGroup";
import MultiSelectConfigOption from "../../../../dto/Form/MultiSelectConfigOption";

export default class MultiSelect extends React.Component<IMultiSelectProps, MultiSelectState> {

    constructor(props: IMultiSelectProps) {
        super(props);
        this.state = new MultiSelectState();
    }

    public render() {
        let config = this.props.field.config as MultiSelectConfig;

        let selectedOptions = this.getParsedSelectedValues();

        return (
            <div>
                {this.props.field.title && <Label required={this.props.field.required}>{this.props.field.title}</Label>}
                {config.options.map((o) => this.renderOptionGroup(o, selectedOptions, config))}
                {this.props.errorMessage && <div className={`${ColorClassNames.red} ${FontClassNames.small} ${styles.errorMessage}`}>{this.props.errorMessage}</div>}
            </div>
        );
    }

    private renderOptionGroup = (optionGroup: MultiSelectConfigOptionGroup, selectedOptions: string[], config: MultiSelectConfig): JSX.Element => {
        return (
            <div key={optionGroup.title}>
                {optionGroup.title && <Label className={styles.optionGroupLabel}>
                    {!config.singleSelect && <Checkbox checked={selectedOptions.some(s => s === optionGroup.key)} onChange={(_ev, checked) => this.onSelectGroup(optionGroup, selectedOptions, checked, config)} className={styles.optionGroupCheckbox}></Checkbox>}
                    {optionGroup.title}
                </Label>}
                <div className={styles.selectionGroup}>
                    {optionGroup.options.map((o) => this.renderOption(optionGroup, o, selectedOptions, config))}
                </div>
            </div>
        )
    }

    private renderOption(optionGroup: MultiSelectConfigOptionGroup, option: MultiSelectConfigOption, selectedOptions: string[], config: MultiSelectConfig): React.ReactNode {
        return (
            <div key={option.key} className={styles.selectionOption}>
                <Checkbox label={option.label} checked={selectedOptions.some(s => s === option.key)} onChange={(_ev, checked) => this.onSelectedValueChanged(optionGroup, option.key, selectedOptions, checked, config)} styles={{
                    text: {
                        textAlign: "left"
                    }
                }}></Checkbox>
            </div>
        )
    }
    private getParsedSelectedValues = (): string[] => {
        if(!this.props.selectedValues) {
            return [];
        }

        try {
            return JSON.parse(this.props.selectedValues);
        } catch(e) {
            console.error(e);
            return [];
        }
    }

    private onSelectGroup = (optionGroup: MultiSelectConfigOptionGroup, selectedOptions: string[], checked: boolean | undefined, config: MultiSelectConfig): void => {
        selectedOptions = selectedOptions || [];
        if(checked) {
            selectedOptions.push(optionGroup.key);
            for(let option of optionGroup.options) {
                if(!selectedOptions.some(s => s === option.key)) {
                    selectedOptions.push(option.key);
                }
            }
        } else {
            selectedOptions = selectedOptions.filter(s => s !== optionGroup.key);
            for(let option of optionGroup.options) {
                selectedOptions = selectedOptions.filter(s => s !== option.key);
            }
        }

        this.props.onChange(JSON.stringify(selectedOptions));
    }
    
    private onSelectedValueChanged(optionGroup: MultiSelectConfigOptionGroup, key: string, selectedOptions: string[], checked: boolean | undefined, config: MultiSelectConfig): void {
        selectedOptions = selectedOptions || [];
        if(!config.singleSelect) {
            selectedOptions = selectedOptions.filter(s => s !== key);
            if(checked) {
                selectedOptions.push(key);
                let hasAllGroupOptionsSelected = true;
                for(let option of optionGroup.options) {
                    if(!selectedOptions.some(s => s === option.key)) {
                        hasAllGroupOptionsSelected = false;
                        break;
                    }
                }

                if(hasAllGroupOptionsSelected && !selectedOptions.some(s => s === optionGroup.key)) {
                    selectedOptions.push(optionGroup.key);
                }
            } else {
                selectedOptions = selectedOptions.filter(s => s !== optionGroup.key);
            }
        } else {
            if(checked) {
                selectedOptions = [ key ];
            } else {
                selectedOptions = [];
            }
        }
        this.props.onChange(JSON.stringify(selectedOptions));
    }

}